import { atomFamily } from "jotai/utils";

import { AuthoritiesIntervention, CaiEnum } from "types/DigitalJourneySession";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

export const sessionNumVehiclesInvolvedAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`numVehiclesInvolved-${sessionId}`, null as number | null)
);
export const numVehiclesInvolvedAtom = createDerivedSessionAtom<number | null>(sessionNumVehiclesInvolvedAtom);

export const sessionDriverPresentAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`driverPresent-${sessionId}`, null as boolean | null)
);
export const driverPresentAtom = createDerivedSessionAtom<boolean | null>(sessionDriverPresentAtom);

export const sessionInformationOnOtherVehicleAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`informationOnOtherVehicle-${sessionId}`, null as boolean | null)
);
export const informationOnOtherVehicleAtom = createDerivedSessionAtom<boolean | null>(
  sessionInformationOnOtherVehicleAtom
);

export const sessionNumInjuredPeopleAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`numInjuredPeople-${sessionId}`, null as number | null)
);
export const numInjuredPeopleAtom = createDerivedSessionAtom<number | null>(sessionNumInjuredPeopleAtom);

export const sessionAmicableSignedAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`cai-${sessionId}`, null as CaiEnum | null)
);
export const amicableSignedAtom = createDerivedSessionAtom<CaiEnum | null>(sessionAmicableSignedAtom);

export const sessionAuthoritiesInterventionAtom = atomFamily((sessionId: string) =>
  createPersistedAtom(`authoritiesIntervention-${sessionId}`, null as AuthoritiesIntervention | null)
);
export const authoritiesInterventionAtom = createDerivedSessionAtom<AuthoritiesIntervention | null>(
  sessionAuthoritiesInterventionAtom
);
